import { render, staticRenderFns } from "./VersionInsert.vue?vue&type=template&id=0dd28502&scoped=true&"
import script from "./VersionInsert.vue?vue&type=script&lang=js&"
export * from "./VersionInsert.vue?vue&type=script&lang=js&"
import style0 from "./VersionInsert.vue?vue&type=style&index=0&id=0dd28502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd28502",
  null
  
)

export default component.exports